module.exports = __webpack_public_path__ + "img/QAT.f15882f1.svg";